import DefaultComparers from '../../Comparers/DefaultComparers';
import ReverseComparer from '../../Comparers/ReverseComparer';
import MapComparer from '../../Comparers/MapComparer';
export default function orderByDescending(array, selector, comparer = DefaultComparers.DefaultComparer) {
    const mapComparer = new MapComparer(selector, new ReverseComparer(comparer || DefaultComparers.DefaultComparer));
    return array.sort((a, b) => mapComparer.compare(a, b));
}
